import request from '@/utils/request'
import { BASE_API } from '@/api/baseUrl'

/**
 * 发货计划执行情况明细
 * @param data
 */
export function apiFindShippingPlanImplementReport(data) {
  return request({
    url: BASE_API() + '/wantgoodsreport/findShippingPlanImplementReport',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/report.js